module.exports = __webpack_public_path__ + "static/img/3.ad90e42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/3.png
// module id = 0Ryl
// module chunks = 0